import { render, staticRenderFns } from "./Convocation.vue?vue&type=template&id=5755085c"
import script from "./Convocation.vue?vue&type=script&lang=js"
export * from "./Convocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports